import I18n from 'I18n';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIChangeArrow from 'UIComponents/icon/icons/UIChangeArrow';
import H5 from 'UIComponents/elements/headings/H5';
import Small from 'UIComponents/elements/Small';
import { Text } from 'foundations-components/components/Text';
import { EERIE } from 'HubStyleTokens/colors';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CLOSED_WON, GAP, FORECAST_SUBMISSION } from '../../constants/DataWells';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TIME_FRAME_TEXT = {
  [CLOSED_WON]: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dataWells.timeFrames.weekOverWeek_closeDate"
  }),
  [GAP]: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dataWells.timeFrames.weekOverWeek_closeDate"
  }),
  [FORECAST_SUBMISSION]: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dataWells.timeFrames.weekOverWeek_generic"
  })
};
const ChangePopover = ({
  change,
  children,
  currencyCode,
  currentAmount,
  isOpen,
  isPercentChangeIndicator,
  percentChange,
  previousAmount,
  setIsOpen,
  title,
  wellType
}) => {
  const isIncrease = currentAmount > previousAmount;
  const timeFrameText = wellType && TIME_FRAME_TEXT[wellType] ? TIME_FRAME_TEXT[wellType] : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dataWells.timeFrames.weekOverWeek_generic"
  });
  return /*#__PURE__*/_jsx(UIPopover, {
    autoPlacement: false,
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: title
      }),
      body: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "p",
          typography: "body-100",
          marginBlockStart: "0",
          marginBlockEnd: "200",
          children: timeFrameText
        }), /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          justify: "start",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "p",
            typography: "body-200",
            margin: "0",
            children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
              currencyCode: currencyCode,
              maximumFractionDigits: 2,
              value: previousAmount
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            className: "m-left-6 m-right-6",
            color: EERIE,
            name: "next",
            screenReaderText: "to",
            size: 20
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            typography: "heading-100",
            margin: "0",
            children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
              currencyCode: currencyCode,
              maximumFractionDigits: 2,
              value: currentAmount
            })
          })]
        })]
      }),
      footer: previousAmount ? /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        children: [/*#__PURE__*/_jsx(UIChangeArrow, {
          use: isIncrease ? 'increase' : 'decrease',
          size: 8
        }), /*#__PURE__*/_jsx(Small, {
          children: isPercentChangeIndicator ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: isIncrease ? 'dataWells.weeklyChange.increase_amount' : 'dataWells.weeklyChange.decrease_amount',
            options: {
              amount: I18n.formatIntlCurrency(Math.abs(change), {
                currencyCode
              })
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: isIncrease ? 'dataWells.weeklyChange.increase' : 'dataWells.weeklyChange.decrease',
            options: {
              percentChange: I18n.formatPercentage(Math.abs(percentChange))
            }
          })
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {})
    },
    onOpenChange: evt => setIsOpen(evt.target.value),
    open: isOpen,
    placement: "bottom",
    children: children
  });
};
export default ChangePopover;